import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogContent } from "@angular/material/dialog";
import { ProtocolService } from "../../../../services/protocol.service";
import { ProtocolAttachment } from "../../../../entities/protocol-attachment";
import { NgOptimizedImage } from "@angular/common";
import { finalize, first } from "rxjs";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FileService } from "../../../../services/file.service";
import { MatMenuModule } from "@angular/material/menu";
import * as fs from "file-saver";
import { MitpManagerService } from "../../../../services/mitp-manager.service";
import { ProtocolAttachmentShareComponent } from "../protocol-attachment-share/protocol-attachment-share.component";
import { DocumentViewerService } from "../../../../services/document-viewer.service";
import { TranslatePipe } from "@tolgee/ngx";

@Component({
	selector: "app-protocol-attachments-list",
	imports: [
		MatIconModule,
		MatButtonModule,
		MatDialogClose,
		MatDialogContent,
		MatProgressSpinnerModule,
		NgOptimizedImage,
		MatMenuModule,
		TranslatePipe,
	],
	templateUrl: "./protocol-attachments-list.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./protocol-attachments-list.component.scss",
})
export class ProtocolAttachmentsListComponent {
	data = inject(MAT_DIALOG_DATA);
	fileService = inject(FileService);
	private manager = inject(MitpManagerService);
	private protocolService = inject(ProtocolService);
	private documentViewer = inject(DocumentViewerService);
	private dialog = inject(MatDialog);

	attachments: ProtocolAttachment[] = [];
	isLoading = true;

	constructor() {
		const data = this.data;
		const protocolService = this.protocolService;

		protocolService
			.getAttachments(data)
			.pipe(
				first(),
				finalize(() => (this.isLoading = false))
			)
			.subscribe((attachments) => {
				this.attachments = attachments;
			});
	}

	downloadAttachment(attachment: ProtocolAttachment): void {
		this.manager.showLoading(true);
		this.protocolService.downloadProtocolAttachment(this.data, attachment.id).subscribe({
			next: (response) => {
				this.manager.showLoading(false);
				const file = new Blob([response.body], {
					type: this.fileService.getMimeType(attachment.extension) || "",
				});
				fs.saveAs(file, `${attachment.label}.${attachment.extension}`);
			},
			error: () => {
				this.manager.showLoading(false);
			},
		});
	}

	shareAttachment(attachment: ProtocolAttachment): void {
		this.dialog.open(ProtocolAttachmentShareComponent, {
			data: {
				protocolId: this.data,
				attachment: attachment,
			},
			width: "600px",
			disableClose: true,
			autoFocus: false,
		});
	}

	view(attachment: ProtocolAttachment): void {
		this.protocolService.downloadProtocolAttachment(this.data, attachment.id).subscribe({
			next: (response) => {
				const doc = new Uint8Array(response.body);
				this.documentViewer.viewDocument(doc);
			},
		});
	}
}
